<template lang="pug">
div 
    alert-modal(ref="confirm" cancelable=true :alertText="alertText" @confirm="confirmConfirmation" @cancel="cancelConfirmation")
    b-button(size='sm', variant='outline-secondary', v-on:click='show', v-if='showButtonVisible')
        | {{config.showButtonHtml}}
    b-modal#basePictureModal.text-sm-left(:ref="'basePictureModal'", centered='', hide-footer='', @hidden="onHidden", @shown="onShown")
        // Header
        template(slot='modal-header')
            .modal-photo-container(v-if="config.showPicture")
                picture-placeholder(:textIn="config.modalTitle" :pictureUrl="config.pictureUrl")
            .modal-toolbar
                span(v-if="!isEditing", v-on:click="deleteUnitType")
                    i.delete-unit-type.fi-trash.nav-icon.modal-btn
                span(v-on:click="toggleEditMode")
                    i.save-unit-type.fi-save.nav-icon.modal-btn(v-if="isEditing")
                    i.edit-unit-type.fi-pencil.nav-icon.modal-btn(v-else="")
                span.modal-btn(v-on:click='hide')
                    i.fi-x.nav-icon 
            h4.modal-title {{config.modalTitle}}
            b-nav.modal-nav-bar(:class="{'modal-nav-bar-no-picture':(!!!config.showPicture)}")
                b-nav-item.modal-nav-link(v-for='(tab,index) in tabs', v-bind:key='tab.title', @click='currentActiveTab=tab.id', :class='{navLinkActive:(tab.id == currentActiveTab)}')  {{tab.title.toUpperCase()}}

        // Content
        div(v-if="'error'==currentActiveTab")
            .tab-load-error Error in Tab Load
        div(v-else-if="'details' == currentActiveTab")
            info-row.info-main-row.py-1(:title="$t('unit_type.name').toLowerCase()" :sizing="4")
                span(:class="{ hidden: isEditing }") {{ unitType.unit_type_name }}
                b-form-input#unit-type-name.input-info-field(
                    v-model="unitType.unit_type_name",
                    type="text",
                    :class="{ hidden: !isEditing }",
                    :state="unitNameValid",
                    :value="unitType.unit_type_name",
                    :placeholder="$t('unit_type.name_placeholder')",
                    aria-describedby="unit-name-feedback"
                    @change="$v.unitType.unit_type_name.$touch",
                )
            info-row.info-main-row.py-1(:title="$t('unit_type.rate').toLowerCase()" :sizing="4")
                span(:class="{ hidden: isEditing }") {{ unitType.base_rate }}
                b-form-input#unit-type-rate.input-info-field(
                    v-model="unitType.base_rate",
                    type="number",
                    :state="unitRateValid",
                    :value="unitType.base_rate",
                    :placeholder="$t('unit_type.rate_placeholder')",
                    :class="{ hidden: !isEditing }",
                    aria-describedby="unit-rate-feedback"
                    @change="$v.unitType.base_rate.$touch",
                )
            info-row.info-main-row.py-1(:title="$t('unit_type.description').toLowerCase()" :sizing="4")
                span(:class="{ hidden: isEditing }") {{ unitType.unit_type_description }}
                b-form-input#unit-type-description.input-info-field(
                    v-model="unitType.unit_type_description",
                    type="text",
                    :class="{ hidden: !isEditing }",
                    :state="unitDescriptionValid",
                    :value="unitType.unit_description",
                    :placeholder="$t('unit_type.description_placeholder')",
                    aria-describedby="unit-description-feedback"
                    @change="$v.unitType.unit_type_description.$touch",
                )
                //- temp commented out. needs to be looped in with subscription handlers
            //- info-row.info-main-row.py-1(:title="$t('unit_type.show_in_db').toLowerCase()" :sizing="4")
            //-     span(:class="{ hidden: isEditing }") {{ unitType.show_in_db ? $t('yes') : $t('no') }}
            //-     toggle-button.active-toggle(
            //-         :value="unitType.show_in_db"
            //-         :sync="true"
            //-         :labels="{ checked: $t('yes'), unchecked: $t('no') }"
            //-         :width="100"
            //-         :height="33"
            //-         :class="{ hidden: !isEditing }"
            //-         style="font-size: 16px;"
            //-         color="#82C7EB"
            //-         @change="unitType.show_in_db = (($event.value) ? true : false)"
            //-     )

    slot(name='button')
</template>

<script>
import BasePictureModal from "./BasePictureModal";
import AlertModal from "@/components/modals/AlertModal";
import InfoRow from "@/components/InfoRow";
import { required, minLength, maxlength } from "vuelidate/lib/validators";

export default {
  name: "UnitTypeModal",
  extends: BasePictureModal,
  components: {
    InfoRow,
    AlertModal,
  },
  data() {
    return {
      config: {
        showButtonHtml: "Add Room",
        showButton: false,
        modalTitle: "Room Type Information",
      },
      currentActiveTab: "details",
      tabs: [
        {
          title: "Details",
          id: "details",
        },
      ],
      unitType: {
        unit_type_name: null,
        base_rate: null,
        unit_type_description: null,
        show_in_db: true,
      },
      unit_type_id: 0,
      is_used: false,
      isNewRecord: false,
    };
  },
  mounted() {
    this.unitType = {
      unit_type_name: null,
      base_rate: null,
      unit_type_description: null,
      show_in_db: true,
    };
  },
  computed: {
    unitNameValid: function () {
      return (
        !this.$v.unitType.unit_type_name.$dirty ||
        !this.$v.unitType.unit_type_name.$invalid
      );
    },
    unitRateValid: function () {
      return (
        !this.$v.unitType.base_rate.$dirty ||
        !this.$v.unitType.base_rate.$invalid
      );
    },
    unitDescriptionValid: function () {
      return (
        !this.$v.unitType.unit_type_description.$dirty ||
        !this.$v.unitType.unit_type_description.$invalid
      );
    },
    alertText: function () {
      return (
        "Are you sure you want to delete " + this.unitType.unit_type_name + "?"
      );
    },
  },
  methods: {
    onHidden() {
      this.unitType = {
        unit_type_name: null,
        base_rate: null,
        unit_type_description: null,
        show_in_db: true,
      };
    },
    edit(_record) {
      if (_record) {
        this.isEditing = false;
        this.isNewRecord = false;
        this.unitType.unit_type_name = _record.unit_type_name;
        this.unitType.unit_type_description = _record.unit_type_description;
        this.unitType.base_rate = _record.base_rate;
        this.unitType.show_in_db = !!_record.show_in_db;
        this.unitType.id = _record.id;
        this.is_used = _record.is_used;
        this.show();
      } else {
        this.isEditing = true;
        this.isNewRecord = true;
        this.show();
      }
    },
    toggleEditMode() {
      if (this.isEditing) {
        if (this.$v.$invalid) {
          this.errorNotification("Check input fields");
          return;
        }
        if (this.isNewRecord) {
          this.handleAddUnitType();
        } else {
          this.handleEditUnitType();
        }

        this.isEditing = false;
      } else {
        this.isEditing = true;
      }
    },
    handleAddUnitType() {
      this.$store
        .dispatch("addUnitType", this.unitType)
        .then(() => {
          this.hide();
          this.$emit("hide");
          this.$emit("updated");
          this.infoNotification(
            this.unitType.unit_type_name + " successfully created."
          );
        })
        .catch((_msg) => {
          this.errorNotification(_msg);
          this.isEditing = true;
        });
    },
    handleEditUnitType() {
      this.$store
        .dispatch("updateUnitType", this.unitType)
        .then(() => {
          this.infoNotification(
            this.unitType.unit_type_name + " successfully updated."
          );
        })
        .catch((_msg) => {
          this.errorNotification(_msg);
          this.isEditing = true;
        });
    },
    deleteUnitType() {
      if (this.is_used) {
        this.errorNotification(
          "This unit type has been used for the bookings, so it can not be deleted"
        );
        return;
      }
      this.$refs.confirm.open();
    },
    cancelConfirmation() {
      this.$refs.confirm.close();
    },
    confirmConfirmation() {
      this.$store
        .dispatch("deleteUnitType", this.unitType.id)
        .then(() => {
          this.infoNotification("Room type successfully deleted.");
          this.$store.dispatch("fetchAccommodations");
        })
        .catch((_msg) => {
          this.errorNotification(_msg);
          this.isEditing = true;
        });
      this.hide();
    },
  },
  validations: {
    unitType: {
      unit_type_name: {
        required,
        minLength: minLength(1),
      },
      base_rate: {
        required,
      },
      unit_type_description: {
        required,
        minLength: minLength(1),
      },
    },
  },
};
</script>

<style>
div.invalid-feedback {
  line-height: initial;
  margin: 0px;
}

.form-control.is-valid {
  border-color: initial;
}
</style>

<style scoped>
i.nav-icon {
  font-size: 1.8rem;
  padding: 3px;
}
</style>
